var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._127JuAk7StnWhQAN86rw9d {\n  height: 2.83333rem;\n  width: 7.625rem;\n  background: url(" + escape(require("./blue.png")) + ") no-repeat center/contain;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  color: #fff;\n  font-size: 1.25rem;\n  font-weight: bold;\n  letter-spacing: 0.1875rem; }\n  ._127JuAk7StnWhQAN86rw9d._3qe6E8fS6050emBUMSrccU {\n    background-image: url(" + escape(require("./green.png")) + "); }\n", ""]);

// exports
exports.locals = {
	"container": "_127JuAk7StnWhQAN86rw9d",
	"submit": "_3qe6E8fS6050emBUMSrccU"
};